export default __webpack_public_path__ + "static/media/(11).209e69e3.jpg";